import { supabase } from "utils/supabase";

export const getDeviceId = () => {
  let deviceId = localStorage.getItem("enarm_apex_device_id");

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("enarm_apex_device_id", deviceId);
  }

  return deviceId;
};

export const getDeviceName = () => {
  const platform = navigator.platform || "Dispositivo";
  const userAgent = navigator.userAgent || "";

  if (userAgent.includes("Windows")) return `Windows - ${platform}`;
  if (userAgent.includes("Mac")) return `Mac - ${platform}`;
  if (userAgent.includes("iPhone")) return "iPhone";
  if (userAgent.includes("Android")) return "Android";

  return platform;
};

export const startDeviceSession = async (force = false) => {
  const deviceId = getDeviceId();

  const { data, error } = await supabase.rpc("start_device_session", {
    p_device_id: deviceId,
    p_device_name: getDeviceName(),
    p_user_agent: navigator.userAgent,
    p_force: force,
  });

  if (error) {
    console.error("Error iniciando dispositivo:", error);
    return {
      allowed: false,
      reason: "error",
      error,
    };
  }

  if (data?.allowed && data?.session?.id) {
    localStorage.setItem("enarm_apex_device_session_id", data.session.id);
  }

  return data;
};

export const sendDeviceHeartbeat = async () => {
  const deviceId = getDeviceId();
  const sessionId = localStorage.getItem("enarm_apex_device_session_id");

  const { data, error } = await supabase.rpc("heartbeat_device_session", {
    p_device_id: deviceId,
    p_session_id: sessionId,
  });

  if (error) {
    console.error("Error en heartbeat:", error);
    return {
      allowed: false,
      reason: "error",
      error,
    };
  }

  return data;
};